module.exports = "/assets/12c52715c87d839f13c4680e031d49e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/YV.png
// module id = 2044
// module chunks = 0